import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import BedbankService from '~/services/BedbankService';

export const potentialPropertyMappingQueryKeys = {
  all: ['bedbank', 'potentialPropertyMappings'] as const,
  list: () => [...potentialPropertyMappingQueryKeys.all, 'list'] as const,
};

export function usePotentialPropertyMappings() {
  return useQuery({
    queryKey: potentialPropertyMappingQueryKeys.list(),
    queryFn: () => BedbankService.getPotentialPropertyMappings(),
  });
}

export function useApprovePotentialPropertyMappings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (mappingIds: Array<string>) =>
      Promise.allSettled(mappingIds.map((id) => BedbankService.approvePotentialPropertyMapping(id))),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: potentialPropertyMappingQueryKeys.all });
    },
  });
}

export function useRejectPotentialPropertyMappings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (mappingIds: Array<string>) =>
      Promise.allSettled(mappingIds.map((id) => BedbankService.rejectPotentialPropertyMapping(id))),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: potentialPropertyMappingQueryKeys.all });
    },
  });
}
